{
    "applicationList":{
        "applicationName":"Application Name",
        "description":"Description",
        "applicationURL":"Application URL",
        "applicaitonScopeEndPoint":"Application Scope EndPoint"
    }
}